export interface MessageAreaProps {
  channelId: string | null;
  workspaceId: string | null;
  onSelectChannel?: (id: string) => void;
  onToggleTerminal?: () => void;
  /** Mobile-only: open the Sidebar Sheet. Wired by AppShell. Undefined on
   *  desktop, where the hamburger button is `md:hidden`. */
  onOpenMobileSidebar?: () => void;
  targetMessageId?: string | null;
  targetThreadId?: string | null;
  onTargetMessageHandled?: () => void;
  /** Best-effort app-level hint used before the channel composite arrives. */
  isDmChannelHint?: boolean;
  pendingCallJoin?: {
    channelId: string;
    callType: "audio" | "video";
    channelName: string;
  } | null;
  onPendingCallJoinHandled?: () => void;
  aboveComposer?: React.ReactNode;
  /**
   * True when this MessageArea instance is mounted but not the active one
   * (i.e. multiplexed / kept-alive). Gates global window event listeners
   * (terminal:*) so only the active instance responds — without this, N
   * mounted instances would each fire the same mutator for a single
   * terminal event.
   */
  hidden?: boolean;
}

/** Default cap for normal browsing. */
export const MESSAGE_MAX_LIMIT = 5000;

/** Hard ceiling for deep-link resolution (`bypassCap`). */
export const MESSAGE_ABSOLUTE_LIMIT = 50000;

/** Join badge auto-expires after 5 minutes — see `useActiveCall`. */
export const CALL_ACTIVE_WINDOW_MS = 5 * 60 * 1000;
